import BaseModel from "../base/baseModel";

export default class ClienteProdutoUsoEspecialModel extends BaseModel {
    id?: number = null;
    produtoId: number = null;
    produtoDescricao?: string;
    clienteId: number = null;
}
